<script>
import resources from './resources'

export default {
  name: 'identification',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-identificacao-profissional.white-bg.wrapper.gadget(:class="{'full-width' : sideBySideIdentification, 'half-width' : !sideBySideIdentification}")
    .gadget-title
      | Perfil Profissional
    .actions(:class="{'active': sortableIdentificationIsActive}")

      span.icon(@click.prevent="sortableIdentification()") 
      ul
        li.exclude Remover
        li.half-width(@click.prevent='sideBySideIdentification = false') Lado a Lado
        li.full-width(@click.prevent='sideBySideIdentification = true') Tela Inteira

    .col-xs-8.col-xs-offset-2.col-md-2.col-md-offset-0.col-lg-offset-0.profile-picture(v-for="summary in summaries")
      img.img-circle(:src='summary.avatar')

    .col-xs-12.col-md-5(v-for="summary in summaries")
      label.light-red Profissional
      h3.medium-gray {{ summary.name }}
      label.light-red Especialidade Médica
      h4.medium-gray {{ summary.specialities }}
    .half-width-margin

    .col-xs-12.col-md-5(v-for="summary in summaries")
      label.light-red CRM
      h3.medium-gray {{ summary.document }}-{{ summary.state }}
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/professional/gadget/components/identification/identification.vue